












































import { Emit, Prop, VModel, Vue } from "vue-property-decorator";
import Component from "vue-class-component";
import FileCard from "@/custom/page/filemanager/file/FileCard.vue";
import FileGeodeticService from "@/entities/file-geodetic/file-geodetic.service";
import { format } from "date-fns";
import PreviewFileDialog from "@/custom/page/common/PreviewFileDialog.vue";
import { IFileGeodetic } from "@/shared/model/file-geodetic.model";

@Component({ components: { PreviewFileDialog, FileCard } })
export default class FileGallery extends Vue {
  @Prop() title!: string;
  @VModel() items!: { [key: string]: any }[];

  lastSelectId = undefined;
  test = false;

  shiftSelect(id, select) {
    // console.log('id=', id);
    // console.log('lastSelectId=', this.lastSelectId);
    // console.log('select=', select);
    if (select) {
      if (this.lastSelectId !== undefined) {
        const minId = this.lastSelectId < id ? this.lastSelectId : id;
        const maxId = this.lastSelectId > id ? this.lastSelectId : id;
        for (let i = minId + 1; i <= maxId; i++) {
          this.items[i].select = true;
        }
        this.$forceUpdate();
      }
    }
  }

  formatDateTime(date) {
    const d = new Date(date);
    return format(d, 'dd/MM/yyyy HH:mm:ss');
  }

  @Emit()
  onSelectChange(id, val) {
    this.items[id].select = val;

    if (val) {
      this.lastSelectId = id;
    } else {
      this.lastSelectId = undefined;
    }
  }

  getImgThumbnailUrl(item) {
    const fileGeodeticService = new FileGeodeticService();
    return fileGeodeticService.thumbnail(item.id);
  }

  dialogImagePreview = {
    open: false,
    title: '',
    fileGeodetic: null,
  };

  openPreviewDialog(item: IFileGeodetic) {
    if (item.map2d) {
      this.$router.push(`/map2d/${item.map2d.id}`);
    } else if (item.model3d) {
      this.$router.push(`/model3d/${item.model3d.id}`);
    } else if (item.vr360) {
      this.$router.push(`/vr360/${item.vr360.id}`);
    } else if (item.thumbnailFilePath) {
      this.dialogImagePreview.title = `${item.fileName}`;
      this.dialogImagePreview.fileGeodetic = item;
      this.dialogImagePreview.open = true;
    }
  }

  @Emit()
  openDetail() {}

  toSelectAllState = true;

  selectAll() {
    if (this.toSelectAllState) {
      this.items.forEach(item => (item.select = true));
    } else {
      this.items.forEach(item => (item.select = false));
    }
    this.toSelectAllState = !this.toSelectAllState;
    this.$forceUpdate();
  }
}
